// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"879":"6ad9cc8f","963":"d2e5eb0b"}[chunkId] + ".chunk.js";
};